import axios from 'axios';
import DataDef from '../sections/datadef';
import ApiGet from '../sections/mainheader/apiget';


class UserService {

    constructor(apiUrl) {

        this.GetApiUrl = apiUrl;
        this.GetUsers = () => (axios.get(`${this.GetApiUrl}user/GetUsers`));

        this.GetColumns = (menuName) => (DataDef(menuName));

        this.GetCreateUserControls = () => (axios.get(`${this.GetApiUrl}user/GetCreateUserControls`));

        this.GetUserControls = () => (axios.get(`${this.GetApiUrl}User/GetUserControls`));

        this.AddUser = (payload) => (axios.post(`${this.GetApiUrl}user/AddUser`, payload));

        this.UpdateUser = (payload) => (axios.post(`${this.GetApiUrl}user/UpdateUser`, payload));

        this.DeleteUser = (dataRow) => (axios.get(`${this.GetApiUrl}user/DeleteUser?id=${dataRow}`));

        this.GetUserDetails = (id) => axios.get(`${this.GetApiUrl}user/GetUserDetails?id=${id}`);

        this.SearchUser = `${this.GetApiUrl}user/SearchUser`;

        this.GetDynamicUISearchControls = () => (axios.get(`${this.GetApiUrl}DynamicUI/GetDynamicUISearchControl`));

        this.GetDynamicUIList = () => (axios.get(`${this.GetApiUrl}DynamicUI/GetDynamicUIList`));

        
        this.GetDynamicUIData = (payload) => (axios.post(`${this.GetApiUrl}DynamicUI/SearchDynamicUIData`, payload));


        this.ClaimDocumentDetailsReport = `${this.GetApiUrl}DynamicUIReport/ClaimDocumentDetailsReport`;

    }
}
export default ApiGet().then((apiUrl) => new UserService(apiUrl));
